import {Component, HostListener, Input, OnDestroy, OnInit} from '@angular/core';
import {GenericActionComponent, GenericActionComponentsMethods} from "../generic-action.component";
import {VetineoVisitTypeMinutes} from "../../models/vet-doctor-vet-visit-type.model";
import {VImage} from "../../models/vet-clinic.model";
import {VetClinicPetSpecies} from "../../models/vet-clinic-pet-species.model";
import {VetineoVisitTypeBundle} from "../../models/vetineo-visit-type-bundle.model";
import {EMPTY, Subscription} from "rxjs";
import {VetClinicData} from "../../models/vet-clinic-data.model";
import {CommonUtils} from "../../utils/common";
import {AppStateService} from "../../providers/app-state.service";
import {ModalController} from "@ionic/angular";
import {TranslateService} from "@ngx-translate/core";
import {VetClinicPetSpeciesService} from "../../providers/vet-clinic-pet-species.service";
import {VetineoVisitTypeBundleService} from "../../providers/vetineo-visit-type-bundle.service";
import {VetineoVisitTypeCategory, VetineoVisitTypeSubCategory} from "../../models/vetineo-visit-type-category.model";
import {Client} from "../../models/client.model";
import {VetDoctorVetVisitTypeService} from "../../providers/vet-doctor-vet-visit-type.service";
import {finalize, switchMap, tap} from "rxjs/operators";
import {PetSpeciesGroup} from "../../models/pet-species-group.model";
import {SelectSpeciesModalComponent} from "../select-species-modal/select-species-modal.component";

@Component({
  selector: 'app-edit-vetineo-visit-type-bundle',
  templateUrl: './edit-vetineo-visit-type-bundle.component.html',
  styleUrls: ['./edit-vetineo-visit-type-bundle.component.scss'],
})
export class EditVetineoVisitTypeBundleComponent extends GenericActionComponent implements OnInit, OnDestroy, GenericActionComponentsMethods {

  @Input() vetineoVisitTypeBundle: VetineoVisitTypeBundle;
  @Input() selectedCategory: VetineoVisitTypeCategory;
  @Input() selectedSubCategory: VetineoVisitTypeSubCategory;
  @Input() clientSelected: Client

  hasUnsavedChanges: boolean = false;
  maxTextAreaLength = 255;
  titleOnEdit = 'Ustawienia domyślne typu wizyty';
  titleOnAdd = 'Konfiguruj ustawienia domyślne typu wizyty';
  images: VImage[];
  isBusy: boolean;
  petSpecies: VetClinicPetSpecies[] = [];
  petSpeciesGroups: PetSpeciesGroup[];
  dataLoaded: boolean = false;
  private alertPresented: boolean = false;
  private previousTextAreaLength: number;
  private vetcodeId: any;
  vetClinicData: VetClinicData;
  species: VetClinicPetSpecies[] = [];
  minutestoSelect: number[] = [];
  selectedMinutes: number;
  categories: any;
  subscriptions: Subscription = new Subscription();
  allSpecies: boolean;
  tempSpecies: VetClinicPetSpecies[] = [];
  showMinutes: boolean;
  cancellationHoursToSelect: number[] = [1, 2, 3, 4, 5, 6, 7, 8, 9, 10, 11, 12, 15, 16, 24, 36, 48, 72, 96];
  maxTermCancellation: number;
  isCarePlanCategory: boolean;
  infoPL: string;
  isCancellationHoursValid: boolean;
  groupedSpecies: { group: PetSpeciesGroup; species: VetClinicPetSpecies[] }[];

  constructor(
    public commonUtils: CommonUtils,
    private appStateService: AppStateService,
    private modalController: ModalController,
    private translateService: TranslateService,
    private vetClinicPetSpeciesService: VetClinicPetSpeciesService,
    private vetineoVisitTypeBundleService: VetineoVisitTypeBundleService,
    private vetDoctorVetVisitTypeService: VetDoctorVetVisitTypeService
  ) {
    super(commonUtils, appStateService, modalController, translateService);
  }

  ngOnInit() {
    if (!this.vetineoVisitTypeBundle && this.action === 'ADD') {
      this.vetineoVisitTypeBundle = new VetineoVisitTypeBundle();
      this.vetineoVisitTypeBundle.namePL = this.selectedSubCategory.name;
    }
    this.appStateService.updateIsBusySubject(true);
    this.registerSubscription(
      this.vetClinicPetSpeciesService.getGlobalSpecies().pipe(
        tap(species => {
          if (species) {
            this.species = species;
            if (this.vetineoVisitTypeBundle?.servedPetSpecies) {
              this.petSpecies = [...this.vetineoVisitTypeBundle.servedPetSpecies];
            }
          }
        }),
        switchMap(species => {
          return species ? this.vetClinicPetSpeciesService.getGlobalSpeciesGroups() : EMPTY;
        }),
        tap(groups => {
          if (groups) {
            this.petSpeciesGroups = groups;
            this.groupedSpecies = this.groupSpecies();
          }
        }),
        finalize(() => this.appStateService.updateIsBusySubject(false))

      ).subscribe()
    );

    if (this.action === 'ADD') {
      this.componentTitle = 'Dodaj nowy typ wizyty';
      this.actionBtnLabel = 'Dodaj nowy typ wizyty';
      this.actionQuestion = 'Na pewno chcesz dodać nowy typ wizyty?';
      this.actionSuccess = 'Nowy typ wizyty został dodany';
      this.actionError = 'Wystąpił błąd podczas dodawania typu wizyty'

    } else {

      this.componentTitle = 'Ustawienia domyślne typu wizyty';
      this.actionBtnLabel = 'Zapisz zmiany';
      this.actionQuestion = 'Na pewno chcesz zmienić ustawienia domyślne typu wizyty?';
      this.actionSuccess = 'Ustawienia domyślne typu wizyty zostały zmienione';
      this.actionError = 'Wystąpił błąd podczas zmiany ustawień domyślnych typu wizyty';

      this.maxTermCancellation = this.vetineoVisitTypeBundle.maxTermCancellation;
      this.isCancellationHoursValid = ((this.maxTermCancellation > 0) && (this.maxTermCancellation <= this.cancellationHoursToSelect[this.cancellationHoursToSelect.length - 1]));
      this.allSpecies = this.vetineoVisitTypeBundle.allPetSpecies;
      this.showMinutes = this.vetineoVisitTypeBundle.showMinutes;
      this.infoPL = this.vetineoVisitTypeBundle.infoPL;

    }
    this.isCarePlanCategory = this.selectedCategory.code === 'pakiet';
    this.isBusySub = this.appStateService.isBusySubject.subscribe(isBusy => {
      this.isBusy = isBusy;
    });

    super.ngOnInit();
  }

  comparePets(o1, o2) {
    return o1 && o2 ? o1.uuid == o2.uuid : false;
  }

  onSelectShowMinutes($event) {
    this.showMinutes = !!$event.detail.checked;
  }

  handleVisitTypeMultimediaEnabledToggle(event: any) {
    if (event.detail.checked === undefined || event.detail.checked === null) {
      return
    }
    this.vetineoVisitTypeBundle.multimediaEnabled = !!event.detail.checked;
  }

  handleVisitTypePrepaidToggle(event: any) {
    if (event.detail.checked === undefined || event.detail.checked === null) {
      return
    }
    console.log(event);
    this.vetineoVisitTypeBundle.prepaidRequired = !!event.detail.checked;
  }

  handleVisitTypePrepaidPriceChange(event: any) {
    const price = (isNaN(event.detail.value) ? 0 : event.detail.value);
    if (price) {
      this.vetineoVisitTypeBundle.prepaidPrice = price;
    }
  }

  @HostListener('document:keydown.escape')
  async onEsc() {
    const top = await this.modalController.getTop();
    if (top) await top.dismiss(null, 'escape');
  }

  onClose() {
    if (this.hasUnsavedChanges) {
      this.commonUtils.presentYesNoActionSheet('Masz niezapisane zmiany, czy na pewno chcesz zrezygnować z konfiguracji typu wizyty?', 'Tak', 'Nie', 'checkmark', 'close', () => {
        this.hasUnsavedChanges = false;
        this.modalController.dismiss();
      }, () => {
      });
    } else {
      this.modalController.dismiss();
    }
  }


  handleTextAreaKeyDown($event: KeyboardEvent) {
    this.previousTextAreaLength = this.infoPL?.length;
  }

  handleTextAreaKeyUp($event: KeyboardEvent) {
    if (this.infoPL?.length === this.maxTextAreaLength && this.previousTextAreaLength === this.infoPL?.length && !this.alertPresented) {
      this.alertPresented = true;
      const alertDuration = 3000;
      this.commonUtils.presentAlertToast('Osiągnięto maksymalną długość informacji.', alertDuration);
      setTimeout(() => {
        this.alertPresented = false;
      }, alertDuration);
    }
  }

  onAction() {
    if (this.vetineoVisitTypeBundle?.prepaidRequired && (this.vetineoVisitTypeBundle?.prepaidPrice === undefined || this.vetineoVisitTypeBundle?.prepaidPrice < 10)) {
      this.commonUtils.presentAlertToast(`Kwota przedpłaty dla wizyty nie może być większy niż 10`);
    } else {

      if (this.selectedCategory != null && (this.petSpecies.length > 0 || this.allSpecies)) {
        this.commonUtils.presentYesNoActionSheet('Na pewno chcesz zapisać zmiany?', 'Tak', 'Nie', 'checkmark', 'close', () => {

          let serviceMethod;
          this.vetineoVisitTypeBundle.infoPL = this.infoPL;
          this.vetineoVisitTypeBundle.servedPetSpecies = this.petSpecies;
          this.vetineoVisitTypeBundle.vetineoVisitTypeCategoryName = this.selectedCategory.name;
          this.vetineoVisitTypeBundle.vetineoVisitTypeCategoryCode = this.selectedCategory.code;
          if (this.selectedSubCategory) {
            this.vetineoVisitTypeBundle.subCategoryCode = this.selectedSubCategory.code;
            this.vetineoVisitTypeBundle.subCategoryName = this.selectedSubCategory.name;
          }

          if (this.vetineoVisitTypeBundle.vetineoVisitTypeBundleUUID) {
            this.vetineoVisitTypeBundle.uuid = this.vetineoVisitTypeBundle.vetineoVisitTypeBundleUUID;
          }

          this.vetineoVisitTypeBundle.allPetSpecies = this.allSpecies;
          this.vetineoVisitTypeBundle.showMinutes = this.showMinutes;
          if (this.vetineoVisitTypeBundle.termCanBeCancelled) {
            this.vetineoVisitTypeBundle.maxTermCancellation = this.maxTermCancellation;
          }
          this.vetineoVisitTypeBundle.vetcodeId = this.vetcodeId;
          if (this.canSetBundlesForCarePlan()) {
            this.vetineoVisitTypeBundle.isCarePlan = this.isCarePlanCategory;
          }
          this.vetineoVisitTypeBundle.vClientId = this.clientSelected.id;
          if (this.action === 'EDIT') {
            serviceMethod = this.vetineoVisitTypeBundleService.editVetineoVisitTypeBundle(this.vetineoVisitTypeBundle);
          } else {
            serviceMethod = this.vetineoVisitTypeBundleService.addVetineoVisitTypeBundle(this.vetineoVisitTypeBundle);
          }

          this.appStateService.updateIsBusySubject(true);
          this.registerSubscription(serviceMethod.subscribe(async (r: VetineoVisitTypeBundle) => {
            if (r) {
              if (this.vetineoVisitTypeBundle.vetDoctorVetVisitTypes) {
                try {
                  this.appStateService.updateIsBusySubject(true);
                  if (this.vetineoVisitTypeBundle.vetineoVisitTypeBundleUUID) {
                    r.vetDoctorVetVisitTypes = await this.vetDoctorVetVisitTypeService.getByBundleUUID(r.vetineoVisitTypeBundleUUID, this.vetcodeId).toPromise();
                  } else {
                    r.vetDoctorVetVisitTypes = await this.vetDoctorVetVisitTypeService.getByBundleUUID(r.uuid, this.vetcodeId).toPromise();
                  }
                } catch (e) {
                  console.log(e);
                  this.appStateService.updateIsBusySubject(false);
                }
              }
              this.appStateService.updateIsBusySubject(false);
              this.modalController.dismiss(r, this.action);

            } else {
              this.appStateService.updateIsBusySubject(false);
              this.commonUtils.presentAlertToast("Wystąpił błąd podczas zapisu konfiguracji typu wizyty");

            }
          }, error => {
            this.commonUtils.presentAlertToast("Wystąpił błąd podczas zapisu konfiguracji typu wizyty");
            console.log(error)
            this.appStateService.updateIsBusySubject(false);
          }));
        }, () => {
        });
      } else {
        this.commonUtils.presentAlertToast('Wybór kategorii, czasu trwania oraz zwierząt jest niezbędny do zapisania');
      }
    }
  }


  ngOnDestroy() {
    if (this.subscriptions) {
      this.subscriptions.unsubscribe();
    }
  }


  getMinutes() {
    return Object.values(VetineoVisitTypeMinutes)?.filter(value => typeof value === "number" && value);
  }

  getSpecies() {
    return this.species;
  }


  handleEditTermCanBeCancelledToggle($event) {
    if ($event.detail.checked === undefined || $event.detail.checked === null) {
      return
    }
    this.vetineoVisitTypeBundle.termCanBeCancelled = !!$event.detail.checked;
  }

  handleRequreCancellationReasonToggle($event) {
    if ($event.detail.checked === undefined || $event.detail.checked === null) {
      return
    }
    this.vetineoVisitTypeBundle.requireCancellationReason = !!$event.detail.checked;
  }

  onChangeHoursToCancellation(event: any) {
    const value = Math.floor(Number(event.detail.value));
    this.isCancellationHoursValid = ((value > 0) && (value <= this.cancellationHoursToSelect[this.cancellationHoursToSelect.length - 1]));
    if (this.isCancellationHoursValid) {
      this.maxTermCancellation = value;
      console.log(this.maxTermCancellation);
    }
  }


  registerSubscription(sub: Subscription) {
    if (sub) {
      this.subscriptions.add(sub);
    }
  }

  dataNotProvided() {
    return !(this.selectedSubCategory && (this.petSpecies.length > 0 || this.allSpecies)) || (!this.isCancellationHoursValid && this.vetineoVisitTypeBundle.termCanBeCancelled);
  }

  onAllSpeciesChange($event) {
    if ($event.detail.checked) {
      this.tempSpecies = this.petSpecies;
      this.petSpecies = [];
    } else {
      this.petSpecies = this.tempSpecies;
    }
  }


  canSetBundlesForCarePlan() {
    return this.clientSelected?.vetineoCarePlanEnabled;
  }

  getAvailableCharsString() {
    if (this.infoPL) {
      return this.maxTextAreaLength - this.infoPL?.length;
    }
    return this.maxTextAreaLength;
  }


  getSelectedSpeciesText(): string {
    if (!this.petSpecies || this.petSpecies.length === 0) {
      return '';
    }
    return this.petSpecies.map(sp => sp.name).join(', ');
  }

  groupSpecies(): {group: PetSpeciesGroup, species: VetClinicPetSpecies[]}[] {
    const speciesByCode = this.species.reduce((acc, sp) => {
      if (!acc[sp.groupCode]) {
        acc[sp.groupCode] = [];
      }
      acc[sp.groupCode].push(sp);
      return acc;
    }, {} as Record<string, VetClinicPetSpecies[]>);
    const grouped = this.petSpeciesGroups.map(group => ({
      group: group,
      species: speciesByCode[group.code] || []
    }));
    return grouped.sort((a, b) => a.group.orderIdx - b.group.orderIdx);
  }

  async onSelectSpeciesClick() {

    const modal = await this.modalController.create({
      component: SelectSpeciesModalComponent,
      componentProps: {
        petSpecies: this.petSpecies,
        groupedPetSpecies: this.groupedSpecies,
        onModalSave: (updatedSpecies: VetClinicPetSpecies[]) => {
          this.petSpecies = updatedSpecies;
        }
      },
      cssClass: ['stacked-modal', 'wide-modal']
    });

    return await modal.present();
  }
}
